<template>
    <fieldset class="bs3-margin-top">
<!--        <legend>-->
<!--            <i class="fa-light fa-info" aria-hidden="true"></i>-->
<!--            <span class="bs3-margin-left5">{{ 'dictionary.project.sections.other.information' | i18nText(pDictionary) }}</span>-->
<!--        </legend>-->
        <div class="row">
            <div class="col-xs-12">
                <field-value-form
                        :p-currencies="pCurrencies"
                        :p-language="pLanguage"
                        :p-dictionary="pDictionary"
                        :p-urls="pUrls"
                        :p-error-list="pErrorList"
                        :p-src="pSrc"
                        :p-src-id="pSrcId"
                        :p-field-value="pDataForm.fieldValueRef"
                        p-field-input-id="bulkCmdDataForm_fieldValueRef"
                        p-field-input-name-prefix="bulkCmdDataForm.fieldValueRef">
                </field-value-form>
            </div>
        </div>
    </fieldset>
</template>

<script>
import FieldValueForm from "@/components/common/field/form/FieldValueForm.vue";
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
   name: "UpdateFieldValueCmdForm",
   components: {FieldValueForm},
   mixins: [BaseMixin, FormMixin, FormatMixin],
   props: {
      pDataForm: Object
   }
}
</script>

<style scoped>

</style>